import { gql } from "@apollo/client";

const PROJECT_TYPE = `
        id
        external_url
        title
        title_en
        location {
          lat
          lng
        }
        polygon {
          lat
          lng
        }
        cover_img
        description
        description_en
        features {
          title
          icon
          link
        }
        imgs
        icon
        starting_price
        marker_type
        marker_color
        menu_images
        views
        bookable
        condition
        introducing_document
        preview_video {
          title
          link
          thumbnail
        }
        virtual_tour {
          title
          link
          thumbnail
        }
        number_of_apartments
        number_of_floors
        number_of_villas
        number_of_lands
        project_financing_down_payment
        project_cash_down_payment
        meta_data {
          support_banks {
            meta_key_id
            value_type
            value
            icon_url_png
            icon_url_svg
          }
          features {
            meta_key_id
            value_type
            value
            icon_url_png
            icon_url_svg
            meta_key_name {
              ar
              en
            }
          }
          facilities {
            meta_key_id
            value_type
            value
            icon_url_png
            icon_url_svg
            meta_key_name {
              ar
              en
            }
          }
          warranty_and_maintenance {
            meta_key_id
            value_type
            value {
              ar
              en
            }
            icon_url_png
            icon_url_svg
            meta_key_name {
              ar
              en
            }
          }
          after_sale_services {
            meta_key_id
            value_type
            value
            icon_url_png
            icon_url_svg
            meta_key_name {
              ar
              en
            }
          }
        }
        nearby_landmarks {
          landmark_id
          distance_in_km
          name {
            ar
            en
          }
        }
        require_iam_to_book
        project_status
        project_type
        address
        area_min
        area_max
        price_from
        price_to
        phone
        whatsapp
        phone_get
        whatsapp_get
        listing_categories
        real_estate_developer {
          id
          name
          about
          logo_img
        }
        project_cash_down_payment
      `;

export const GET_REAL_ESTATE_DEVELOPERS = gql`
  query {
    Info {
      realEstateDevelopers {
        id
        name
      }
    }
  }
`;

export const BOOK_UNIT = gql`
  mutation bookUnit($project_id: Int!, $listing_id: Int!) {
    RealEstateProjectOperations {
      bookUnit(project_id: $project_id, listing_id: $listing_id)
    }
  }
`;

export const SHOW_INTEREST = gql`
  mutation showInterestInProject($project_id: Int!) {
    RealEstateProjectOperations {
      showInterestInProject(project_id: $project_id)
    }
  }
`;

export const ElasticListingFragment = `fragment ElasticListing on ElasticListing {
  id
  price 
  category
  published
  content
  unit_code
  wc
  beds
  type
  livings
  imgs
  street_width
}`;

export const FindProjectsFragment = `fragment FindProjectsResults on FindResults {
  projects {
    ${PROJECT_TYPE}
    is_exclusive
    project_cash_down_payment
  }
  total
  bookable_projects_total
}`;

export const FindUnitsFragment = `fragment FindUnitsResults on FindResults {
  projects {
    id
    listings {
      ...ElasticListing
    }
  }
  total
  bookable_projects_total
}${ElasticListingFragment}`;

export const FIND_SEARCH_PROJECTS = gql`
  query findSearchProjects(
    $size: Int
    $from: Int
    $sort: SortInput
    $where: WhereInput
    $polygon: [LocationInput!]
    $bookable_project_filter: BookableProjectFilter
    $bookable_unit_filter: BookableUnitFilter
  ) {
    Search {
      find(
        size: $size
        from: $from
        sort: $sort
        where: $where
        polygon: $polygon
        bookable_project_filter: $bookable_project_filter
        bookable_unit_filter: $bookable_unit_filter
      ) {
        ...FindProjectsResults
      }
    }
  }
  ${FindProjectsFragment}
`;
export const FIND_SEARCH_UNITS = gql`
  query findSearchUnits(
    $size: Int
    $from: Int
    $sort: SortInput
    $where: WhereInput
    $polygon: [LocationInput!]
    $bookable_project_filter: BookableProjectFilter
    $bookable_unit_filter: BookableUnitFilter
  ) {
    Search {
      find(
        size: $size
        from: $from
        sort: $sort
        where: $where
        polygon: $polygon
        bookable_project_filter: $bookable_project_filter
        bookable_unit_filter: $bookable_unit_filter
      ) {
        ...FindUnitsResults
      }
    }
  }
  ${FindUnitsFragment}
`;

export const GET_BOOKABLE_PROJECT = gql`
  query GetBookableProject($project_id: Int!) {
    Search {
      bookableProject(project_id: $project_id) {
       ${PROJECT_TYPE}
       listings {
            ...ElasticListing
       }
      }
    }
  }
  ${ElasticListingFragment}
`;

export const GET_REAL_ESTATE_PROJECT_TITLE = gql`
 query GetRealEstateProject($id: Int!) {
    RealEstateProjects {
      getProject(project_id: $id) {
        ${PROJECT_TYPE}
      }
    }
  }
`;
export const GET_REAL_ESTATE_PROJECT = gql`
  query GetRealEstateProject($project_id: Int!, $where: WhereInput) {
    RealEstateProjects {
      getProject(project_id: $project_id) {
        ${PROJECT_TYPE}
      }
    }
     Search {
      find(where: $where, bookable_unit_filter: {}) {
        projects {
          id
          is_exclusive
          project_cash_down_payment
          listings {
            ...ElasticListing
          }
        }
        total
        bookable_projects_total
    }
  }
  }
  ${ElasticListingFragment}
`;

export const GET_REAL_ESTATE_PROJECT_UNITS = gql`
  query getUnits($where: WhereInput) {
    Search {
      find(where: $where, bookable_unit_filter: {}) {
        projects {
          id
          listings {
            ...ElasticListing
          }
        }
        total
        bookable_projects_total
      }
    }
  }
  ${ElasticListingFragment}
`;

export const GET_RED_PROJECT_PHONE = gql`
  query GetRedProjectPhone($project_id: Int!) {
    RealEstateProjects {
      getPhone(project_id: $project_id)
    }
  }
`;

export const GET_RED_PROJECT_WHATSAPP = gql`
  query GetRedProjectPhone($project_id: Int!) {
    RealEstateProjects {
      getWhatsapp(project_id: $project_id)
    }
  }
`;

export const SHOW_INTEREST_MUTATION = gql`
  mutation ShowInterest($project_id: Int!) {
    RealEstateProjectOperations {
      showInterestInProject(project_id: $project_id)
    }
  }
`;

export const GET_DEVELOPER_PROFILE = gql`
  query getRealEstateProjectDeveloper($id: Int!) {
    RealEstateDeveloper {
      get(real_estate_developer_id: $id) {
        name
        phone
        logo_img
        cover_img
        about
        population
        surfaces
        units_count
        projects_count
        social_x
        social_snapchat
        social_instagram
        social_linkedin
        social_tiktok
      }
    }
  }
`;
export const SEARCH_DEVELOPER_PROJECTS = gql`
  query searchDeveloperProjects($id: Int!) {
    RealEstateProjects {
      searchDeveloperProjects(developer_id: $id) {
        total
        total_page
        has_next_page
        list {
          id
          imgs
          title
          address
          title_en
          polygon {
            lat
            lng
          }
          location {
            lat
            lng
          }
          cover_img
          icon
          starting_price
          views
          project_status
          project_type
          address
          area_min
          area_max
          price_from
          price_to
          phone
          whatsapp
          marker_color
          marker_type
          icon
          real_estate_developer {
            id
            name
          }
        }
      }
    }
  }
`;

export const GET_MY_SUBMITTED_PAYMENT_REQUESTS = gql`
  query GetMySubmittedPaymentRequests(
    $buyer_phone_number: String
    $status: RealEstateProjectUnitPaymentStatusEnum
  ) {
    RealEstateProjectOperations {
      getMySubmittedPaymentRequests(
        buyer_phone_number: $buyer_phone_number
        status: $status
      ) {
        total
        payment_requests {
          request_id
          broker_user {
            user_id
            phone
            name
          }
          buyer_user {
            user_id
            phone
            name
          }
          listing_id
          project_id
          status
          transaction_id
          transaction_type
          contract_pdf
          down_payment
          broker_name
          project_name
          unit_code
          buyer_phone_number
          submitted_at
          expired_at
          paid_at
          refunded_at
        }
      }
    }
  }
`;

export const GET_MY_PAYMENT_REQUESTS = gql`
  query GetMyPaymentRequests {
    RealEstateProjectOperations {
      getMyPaymentRequests {
        total
        payment_requests {
          request_id
          broker_user {
            user_id
            phone
            name
          }
          buyer_user {
            user_id
            phone
            name
          }
          listing_id
          project_id
          status
          transaction_id
          transaction_type
          contract_pdf
          down_payment
          broker_name
          project_name
          unit_code
          buyer_phone_number
          submitted_at
          expired_at
          paid_at
          refunded_at
        }
      }
    }
  }
`;
